
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getOrderHistory } from '@/api/customer';
import { UserModule } from '@/store/modules/user';
import dayjs from 'dayjs';

const resourceOptions = [{
  value: '1',
  label: '内部订单'
}, {
  value: '2',
  label: '外部订单'
}, {
  value: '3',
  label: '转入订单'
}, {
  value: '4',
  label: '转出订单'
}, {
  value: '5',
  label: '退回订单'
}];

const orderTypeOptions = [{
  value: '1',
  label: '其他'
}, {
  value: '2',
  label: '维保'
}, {
  value: '3',
  label: '安装'
}, {
  value: '4',
  label: '巡检'
}];

@Component({
  name: 'RecordList',
  components: {
  }
})
export default class extends Vue {
  private formSearch:any = {
    orderNumber: '',
    addtime: '',
    timeRange: [],
    person: '',
    iphone: '',
    address: '',
    isHasBranch: '',
    orderResource: '',
    orderType: ''
  }
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private loadding=false;
  private resourceOptions = resourceOptions
  private orderTypeOptions = orderTypeOptions

  private tableData = []

  created() {
    this.initTimeRange();
    this.getOrderHistory();
  }
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getOrderHistory();
  }

  handlePageSizeChange(size: number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = size;
    this.getOrderHistory();
  }
  private search() {
    this.pagination.currentPage = 1;
    this.getOrderHistory();
  }
  private clearSearch() {
    this.pagination.currentPage = 1;
    this.formSearch = {
      orderNumber: '',
      addtime: '',
      timeRange: [],
      person: '',
      iphone: '',
      address: '',
      isHasBranch: '',
      orderResource: '',
      orderType: ''
    };
    this.initTimeRange();
    this.getOrderHistory();
  }

  private initTimeRange() {
    const threeMonthsAgoTime = dayjs().subtract(3, 'month').hour(0).minute(0).second(0).valueOf();
    const nowTime = new Date().setHours(23, 59, 59, 999);
    this.formSearch.timeRange = [threeMonthsAgoTime, nowTime];
  }

  private getOrderHistory() {

    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;

    pamars.order_num = this.formSearch.orderNumber;
    // pamars.times = this.formSearch.addtime / 1000;
    if (this.formSearch.timeRange && this.formSearch.timeRange.length === 2) {
      pamars.start_time = this.formSearch.timeRange[0] / 1000;
      pamars.end_time = this.formSearch.timeRange[1] / 1000 + +86400;
      if(parseInt(pamars.end_time) -
          parseInt(pamars.start_time) >
        (365 * 24 + 24) * 60 * 60
      ) {
        this.showErrorMsg("最多选择一年的时间范围");
        return;
      }
    }
    pamars.name = this.formSearch.person;
    pamars.mobile = this.formSearch.iphone;
    pamars.address = this.formSearch.address;
    pamars.contain_branch = this.formSearch.isHasBranch ? '1' : '0';
    pamars.order_source = this.formSearch.orderResource;
    pamars.order_type = this.formSearch.orderType;

    pamars.company_level = this.$route.query.customer_level;
    if (this.$route.query && parseInt(this.$route.query.customer_type as string) === 1) {
      pamars.customer_company_id = this.$route.query.company_id;
    } else {
      pamars.customer_user_id = this.$route.query.user_id;
    }
    if (this.$route.query && parseInt(this.$route.query.create_user_id as string) > 0) {
      pamars.create_user_id = this.$route.query.create_user_id;
    }

    pamars.page = this.pagination.currentPage;
    pamars.size = this.pagination.pageSize;
    this.loadding = true;
    getOrderHistory(pamars).then(res => {
      this.loadding = false;
      if (res.data) {
        this.pagination.total = res.data.count || 0;
        this.tableData = res.data.list;
      } else {
        this.pagination.total = 0;
        this.tableData = [];
      }
    }).catch(err => {
      this.loadding = false;
      let msg = err.msg;
      this.pagination.total = 0;
      this.tableData = [];
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
  // 订单详情
  detailHandle(val: any, index: number) {
    let routeData = this.$router.resolve({
      path: '/OrderServicer/todetail',
      query: {
        order_service_id: val.order_service.id,
        company_id: val.order_service.servicer_company_id,
      }
    });
    window.open(routeData.href);
  }

}
